import React, {useState} from "react";
import "./QuoteProjectForm.scss";
import ".././Form.scss";
import Button from "../../Buttons/Button/Button";
import CustomSelect from "../FormFields/Select/CustomSelect";
import { validateForm } from "./QuoteFormValidation";
import { submitQuoteForm } from "../../../services/api/submitFormToApi";


const QuoteProjectForm = ({ onFormSuccess }) => {
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [formData, setFormData] = useState({
        project_type: "",
        budget: "",
        functionalities: []
    });


    const projectTypeOptions = [
        {value: "", label: "Wybierz..."},
        {value: "Strona internetowa", label: "Strona internetowa"},
        {value: "Sklep internetowy", label: "Sklep internetowy"},
        {value: "Landing page", label: "Landing page"},
        {value: "Aplikacja webowa", label: "Aplikacja webowa"},
        {value: "Inne", label: "Inne"},
    ];

    const budgetOptions = [
        {value: "", label: "Wybierz..."},
        {value: "Do 5000 PLN", label: "Do 5000 PLN"},
        {value: "5000-10 000 PLN", label: "5000-10 000 PLN"},
        {value: "10 000-20 000 PLN", label: "10 000-20 000 PLN"},
        {value: "Powyżej 20 000 PLN", label: "Powyżej 20 000 PLN"},
    ];


    const handleCustomSelectChange = (field, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };


    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const form = event.target;
        const validationErrors = validateForm(form);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSubmitStatus('');
            setApiError('');
            return;
        }

        setErrors({});
        setApiError('');
        setIsLoading(true);

        try {
            const formData = new FormData(form);

            // Tworzenie obiektu z danymi formularza
            const formDataObject = {};
            formData.forEach((value, key) => {
                if (key === 'functionalities') {
                    if (!formDataObject[key]) {
                        formDataObject[key] = [];
                    }
                    formDataObject[key].push(value);
                } else {
                    formDataObject[key] = value;
                }
            });

            const finalFormData = {
                ...formDataObject,
                project_type: formData.get('project_type'),
                budget: formData.get('budget')
            };


            const response = await submitQuoteForm(formDataObject);

            if ('data' in response && response.data.success) {
                setSubmitStatus('success');
                form.reset();
                setFormData({
                    project_type: "",
                    budget: ""
                });

                setTimeout(() => {
                    onFormSuccess?.(); // Zamknięcie modala
                    setTimeout(() => setSubmitStatus(''), 4900); // Czyszczenie statusu
                }, 2000);


            } else if ('error' in response) {
                setSubmitStatus('error');
                setApiError(response.error.message);
            }
        } catch (error) {
            setSubmitStatus('error');
            setApiError(error.message || 'Wystąpił nieoczekiwany błąd podczas wysyłania formularza.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="quote-project-form">
            <form className="form send-project-quote" id="send-project-quote" onSubmit={handleFormSubmit}>
                <div className="quote-project-form--inside">
                    {/* Informacje o wysyłce formularza */}
                    {apiError && (
                        <div className="alert-message error-message">
                            <div className="alert alert-danger">
                                {apiError}
                            </div>
                        </div>
                    )}

                    {submitStatus === 'success' && (
                        <div className="alert-message success-message">
                            <div className="alert alert-success">
                                Formularz został wysłany pomyślnie!
                            </div>
                        </div>
                    )}

                    {/* LEFT SIDE OF THE FORM */}
                    <div className="quote-project-form--inside__left">
                        {/* Project Type */}
                        <div className="form-group project-type-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="project_type">Typ projektu *</label>
                                    <CustomSelect
                                        id="project_type"
                                        options={projectTypeOptions}
                                        value={formData.project_type}
                                        onChange={(value) => handleCustomSelectChange("project_type", value)}
                                        error={errors.project_type}
                                    />
                            </div>
                        </div>

                        {/* Do you have a base materials? */}
                        <div className="form-group base-materials-form-row">
                            <div className="form-group--inside">
                                <label>Czy posiadasz materiały bazowe?(logo/teksty/grafiki) *</label>
                                <div className="buttons-group radio-group">
                                    <label>
                                        <input type="radio" name="base_materials" value="Tak" required/>
                                        Tak
                                    </label>
                                    <label>
                                        <input type="radio" name="base_materials" value="Nie" required/>
                                        Nie
                                    </label>
                                    {errors.base_materials && <span className="error">{errors.base_materials}</span>}
                                </div>
                            </div>
                        </div>

                        {/* Do you have a ready graphic design? */}
                        <div className="form-group design-form-row">
                            <div className="form-group--inside">
                                <label>Czy posiadasz gotowy projekt graficzny? *</label>
                                <div className="buttons-group radio-group">
                                    <label>
                                        <input type="radio" name="graphic_design" value="Tak" required/>
                                        Tak
                                    </label>
                                    <label>
                                        <input type="radio" name="graphic_design" value="Nie" required/>
                                        Nie
                                    </label>
                                    {errors.graphic_design && <span className="error">{errors.graphic_design}</span>}
                                </div>
                            </div>
                        </div>

                        {/* What functionalities are required? */}
                        <div className="form-group features-form-row">
                            <div className="form-group--inside">
                                <label>Jakie funkcjonalności są wymagane?</label>
                                <div className="buttons-group checkbox-group">
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Galeria zdjęć"/>
                                        Galeria zdjęć
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="System rezerwacji"/>
                                        System rezerwacji
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Integracja Baselinker"/>
                                        Integracja Baselinker
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Inne integracje"/>
                                        Inne integracje
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Automatyzacja"/>
                                        Automatyzacja
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Płatności online"/>
                                        Płatności online
                                    </label>
                                    <label>
                                        <input type="checkbox" name="functionalities" value="Inne"/>
                                        Inne
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Budget */}
                        <div className="form-group budget-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="budget">Orientacyjny budżet na realizację projektu*</label>
                                    <CustomSelect
                                        id="budget"
                                        options={budgetOptions}
                                        value={formData.budget}
                                        onChange={(value) => handleCustomSelectChange("budget", value)}
                                        error={errors.budget}
                                    />
                            </div>
                        </div>


                        {/* Preferred completion date */}
                        <div className="form-group lead-time-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="completion_date">Preferowany termin realizacji</label>

                                {/*<input type="date" id="completion_date" name="completion_date"/>*/}
                                <div className="date-field-container" onClick={(e) => {
                                    const dateInput = e.currentTarget.querySelector('input[type="date"]');
                                    if (dateInput) {
                                        dateInput.showPicker();
                                    }
                                }}>
                                    <input
                                        type="date"
                                        id="deadline"
                                        name="deadline"
                                        className="form-control"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE OF THE FORM */}
                    <div className="quote-project-form--inside__right">
                        {/* Name and Surname */}
                        <div className="form-group name-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="name_surname">Imię i nazwisko*</label>
                                <input type="text" id="name_surname" name="name_surname" placeholder="Imię i nazwisko"/>
                                {errors.name_surname && <span className="error">{errors.name_surname}</span>}
                            </div>
                        </div>

                        {/* Phone */}
                        <div className="form-group phone-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="phone">Telefon*</label>
                                <input type="tel" id="phone" name="phone" placeholder="Podaj telefon"/>
                                {errors.phone && <span className="error">{errors.phone}</span>}
                            </div>
                        </div>

                        {/* Email */}
                        <div className="form-group email-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="email">Email*</label>
                                <input type="email" id="email" name="email" placeholder="Podaj email"/>
                                {errors.email && <span className="error">{errors.email}</span>}
                            </div>
                        </div>

                        {/* Project Description */}
                        <div className="form-group description-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="project_description">Opis projektu *</label>
                                <textarea
                                    id="project_description"
                                    name="project_description"
                                    placeholder="Opisz krótko swój projekt, cele, branżę i grupę docelową"
                                    required
                                ></textarea>
                                {errors.project_description &&
                                    <span className="error">{errors.project_description}</span>}
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="form-group submit-form-row">
                            <div className="form-group--inside">
                                <Button
                                    disabled={isLoading}
                                    classes={[
                                        "btn",
                                        "btn-submit",
                                        "btn-transparent",
                                        "white",
                                        "btn-form",
                                        "left-to-right-animate",
                                        "white",
                                        isLoading ? "loading" : ""
                                    ]}
                                    text= {isLoading ? "Wysyłanie..." : "Wyślij"}
                                    hasIcon={false}
                                    iconClasses={["dollar-icon"]}
                                    type="submit"/>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    );
};

export default QuoteProjectForm;
